import { ApexApiError } from 'apex-ui-services'
import { closeAccount as closeAccountRemote } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import { ACCOUNT_CLOSING_FAILED, TEMPORARILY_UNAVAILABLE } from './constants'

export const closeAccount = (
  onError: (error: string) => void,
  onSuccess: () => void,
  accountNumber: string,
  replacementFdid?: string
) => {
  closeAccountRemote(accountNumber, replacementFdid)
    .then(onSuccess)
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      if (
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
      ) {
        onError(TEMPORARILY_UNAVAILABLE)
      } else if (httpResponseStatus === HttpResponseStatusCodes.Forbidden) {
        onError(ACCOUNT_CLOSING_FAILED)
      }
    })
}
